let env = {};


// TIH RIO
env.baseURL = 'https://api.tihrio.ares-saude.com.br/api/v1/';
env.normalURL = 'https://api.tihrio.ares-saude.com.br/';
env.mode = 'production';

// env.baseURL = 'http://localhost:8000/api/v1/';
// env.normalURL = 'http://localhost:8000/';
// env.mode = 'homolog';
//env.mode = 'contingencia';
//env.mode = 'production';
//env.mode = 'development';

export default env
